// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PShareOutlinedSvg from "@fishx/icons-svg/es/asn/PShareOutlined";
import FishxIcon from '../components/FishxIcon';

var PShareOutlined = function PShareOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PShareOutlinedSvg
  }));
};

PShareOutlined.displayName = 'PShareOutlined';
export default React.forwardRef(PShareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PShareOutlined.js
// module id = 3623
// module chunks = 0